// components/.jsx

import React from "react";
import { Link, useLocation } from "react-router-dom";

const serviceAreas = [
  { label: "Çakırlar Koltuk Yıkama", path: "/yenimahalle/cakirlar-koltuk-yikama" },
  { label: "Çakırlar Perde Yıkama", path: "/yenimahalle/cakirlar-perde-yikama" },
  { label: "Demet Koltuk Yıkama", path: "/yenimahalle/demet-koltuk-yikama" },
  { label: "İvedik Koltuk Yıkama", path: "/yenimahalle/ivedik-koltuk-yikama" },
  { label: "İvedik Yerinde Yıkama", path: "/yenimahalle/ivedik-yerinde-yikama" },
  { label: "İvedik Perde Yıkama", path: "/yenimahalle/ivedik-perde-yikama" },
  { label: "Batıkent Koltuk Yıkama", path: "/yenimahalle/batikent-koltuk-yikama" },
  { label: "Batıkent Perde Yıkama", path: "/yenimahalle/batikent-perde-yikama" },
  { label: "Ostim Koltuk Yıkama", path: "/yenimahalle/ostim-koltuk-yikama" },
  { label: "Ostim Yerinde Yıkama", path: "/yenimahalle/ostim-yerinde-yikama" },
  { label: "Ostim Perde Yıkama", path: "/yenimahalle/ostim-perde-yikama" },
];

const YenimahalleServiceAreas = () => {
  const location = useLocation();

  return (
      <div className="text-[#003132] mt-0 w-full">
        <h2 className="text-lg font-semibold mb-1 uppercase tracking-wide text-center">YENİMAHALLE HİZMET TÜRLERİ</h2>
  
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full">
          {serviceAreas.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      </div>
    );
  };

export default YenimahalleServiceAreas;
